<template>
  <div :style="style" v-html="newTxet || getText.replace('{{newtest}}','')" />
</template>
  <script>
      import { BsUtil } from 'dida-web-common'
      export default {
          name: 'MarsText',
          props: {
              editableData: {
                  type: Object,
                  default: function() {
                      return {
                          basic: {}
                      }
                  }
              }
          },
          data() {
              return {
                  newTxet: ''
              }
          },
          computed: {
              basicConf: function() {
                  return this.editableData.basic
              },
              getText: function() {
                  const text = this.basicConf.text
                  if (BsUtil.isArray(text)) {
                      const melete = this.$root?.activeData?.melete || []
                      if (text.length === 1 || melete.length === 0) return text[0].text
                      for (let i = 1; i < text.length; i++) {
                          const first = text[i].first
                          for (let j = 0; j < first.length; j++) {
                              if (melete.indexOf(first[j]) > -1) {
                                  return text[i].text
                              }
                          }
                      }
                      return text[0].text
                  }
                  return text
              },
              style: function() {
                  var t = this.basicConf.font || {},
                  e = t.fontSize,
                  n = {
                      fontSize: e + 'px',
                      textAlign: t.textAlign,
                      fontWeight: t.fontWeight,
                      fontFamily: t.fontFamily,
                      textDecoration: t.textDecoration,
                      lineHeight: t.lineHeight,
                      color: this.basicConf.color
                  }
                  if (this.basicConf.isScroll) {
                      n.height = '100%'
                      n.overflowY = 'scroll'
                  }
                  // text-stroke: 2px #FFFFFF;
                  // -webkit-text-stroke: 2px #FFFFFF;

                  if ((n.fontSize = isNaN(Number(e)) ? e : e / 75 + 'rem', this.basicConf.stroke)) {
                      var r = this.basicConf.stroke
                      n.textStroke = ''.concat(r.w / 75, 'rem ').concat(r.color)
                      n['-webkit-text-stroke'] = ''.concat(r.w / 75, 'rem ').concat(r.color)
                      // n.textShadow = ''.concat(0, 'rem ').concat(0, 'rem ').concat(r.w / 75, 'rem ').concat(r.color)
                  }
                  n.letterSpacing = isNaN(Number(t.letterSpacing)) ? t.letterSpacing : t.letterSpacing / 75 + 'rem'
                  return n
              }
          },

          mounted: function() {

          },
          methods: {
              settext(val) {
                  var de = this.getText || ''
                  var ppkey = '{{newtest}}'
                  if (de.indexOf(ppkey) > -1 && val !== undefined) {
                      return de.replace(ppkey, val)
                  }
                  return val || de.replace(ppkey, '')
              },
              changeText(value) {
                  let obj = value.text
                  if (this.basicConf.textKey) {
                      const keys = this.basicConf.textKey.split('.')
                      while (keys.length > 0) {
                          const key = keys.shift()
                          if (obj[key] !== undefined) {
                              obj = obj[key]
                          } else {
                              return this.newTxet = this.settext(value.text)
                          }
                      }
                  }
                  return this.newTxet = this.settext(obj)
              }
          }
      }
      </script>

      <style lang="scss" scoped>
          div{
              white-space: 'pre-wrap ';
              word-break: 'break-all';
              // transform-origin: center center;
              img{
                  width: 100%;
              }
          }
      </style>

